import { Box, SxProps, Typography } from "@mui/material";

import { ArrowDownRight, ArrowUpRight } from "lucide-react";

import { useFormatNumber } from "hooks/useFormatNumber";
import {
  AlertMetric,
  NightReportMetric,
} from "interfaces/nightReport.interface";

export type MetricBadgeProps = {
  showPercent?: boolean;
  delta: number;
  alertMetric?: AlertMetric;
  metric?: NightReportMetric;
  testId?: string;
  sx?: SxProps;
};

export function MetricBadge({
  showPercent,
  delta,
  alertMetric,
  metric,
  testId,
  sx,
}: MetricBadgeProps) {
  const formatNumber = useFormatNumber();

  const shouldAlert = alertMetric && metric?.deviation_alert;

  const deltaText = formatNumber(delta);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.25,
        backgroundColor: shouldAlert
          ? "backgrounds.danger.soft.default"
          : "backgrounds.neutral.soft.default",
        borderRadius: "999px",
        borderStyle: "solid",
        borderWidth: shouldAlert ? 0 : 1,
        borderColor: "borders.neutral.subtle",
        px: 1,
        py: 0.25,
        alignSelf: "center",
        height: 20,
        ...sx,
      }}
    >
      <Typography
        variant="bodyMicroRegular"
        component="span"
        data-testid={"badge-" + testId}
      >
        {showPercent ? `${deltaText}%` : `${deltaText}`}
      </Typography>
      {showPercent && (
        <Box
          sx={{
            color: shouldAlert
              ? "texts.danger.decoration"
              : "texts.neutral.decoration",
          }}
        >
          {delta < 0 ? (
            <ArrowDownRight size={12} data-testid={"down-arrow-" + testId} />
          ) : (
            <ArrowUpRight size={12} data-testid={"up-arrow-" + testId} />
          )}
        </Box>
      )}
    </Box>
  );
}
